export enum AccordionIcon {
    ICON_PLUS = 'ICON_PLUS',
    ICON_ARROW = 'ICON_ARROW',
}
